import { getBankAccountSummaryList } from "../apis/finances/bank";
import { getCardPurchaseSummaries, getCardsList } from "../apis/finances/cards";
import { getStatisticsTradeSummaries } from "../apis/finances/statistics";
import { BANK_DATA } from "../constants/BANK_DATA";
import { CARD_DATA } from "../constants/CARD_DATA";
import { translation } from "./translator";

// 매입 매출 현황 리스트 호출
export const getOverviewTradeSummaries = async (params) => {
  const _params = {
    range: {
      tradeDate: {
        from: params.date[0],
        to: params.date[1]
      }
    }
  }

  let list = {}
  await getStatisticsTradeSummaries(_params)
    .then((res) => {
      list = res.data
    })

  return list
}

// 은행계좌 리스트 호출
export const getOverviewBankAccountList = async (params) => {
  const _params = {
    type: 'normal_account',
    range: {
      tradeTime: {
        from: params.date[0],
        to: params.date[1]
      }
    }
  }

  let list = {}

  await getBankAccountSummaryList(_params)
    .then((res) => {
      list = {
        ...res.data,
        bankAccountSummaries: res.data.bankAccountSummaries.map((bank) => ({
          ...bank,
          bankCompany:
            translation(BANK_DATA, bank.bankCd, "fcode", "name"),
          bankImg: translation(
            BANK_DATA,
            bank.bankCd,
            "fcode",
            "bankImg"
          ),
        }))
      }
    })
    .catch((err) => {
      console.error(err.response);
    });

  return list
}

// 기타거래 리스트 호출
export const getOverviewCashAccountList = async (params) => {
  const _params = {
    type: 'cash_account',
    range: {
      tradeTime: {
        from: params.date[0],
        to: params.date[1]
      }
    }
  }

  let list = {}

  await getBankAccountSummaryList(_params)
    .then((res) => {
      list = res.data
    })
    .catch((err) => {
      console.error(err.response);
    });

  return list
}

// 카드계좌 리스트 호출
export const getOverviewCardList = async () => {
  let list = []

  await getCardsList().then((res) => {
    list = res.data.cards.map((card) => ({
      ...card,
      cardCompany: translation(CARD_DATA, card.cardCd, 'code', 'name')
    }))
  })

  return list
}

// 카드 거래내역
export const getOverviewCardTransList = async (params) => {
  const _params = {
    range: {
      useDate: {
        from: params.date[0],
        to: params.date[1],
      },
    },
  }

  let list = []

  await getCardPurchaseSummaries(_params)
    .then((res) => {
      list = res.data
    })
    .catch((err) => {
      console.error(err.response);
    });

  return list
}